import { useEffect, useState } from 'react';
import { onboardingApi } from '../../../api/recruiting.js';

let rowKey = 0;

export default function Templates() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [tasks, setTasks] = useState([{ key: rowKey++, title: '', ownerRole: 'hr_manager', offsetDays: 0 }]);
  const [error, setError] = useState(null);
  const [notice, setNotice] = useState(null);

  function refresh() {
    setLoading(true);
    onboardingApi
      .listTemplates()
      .then((d) => setItems(d?.items || []))
      .catch((e) => setError(e.response?.data?.message || 'Failed to load'))
      .finally(() => setLoading(false));
  }
  useEffect(refresh, []);

  function updateTask(key, field, value) {
    setTasks((prev) => prev.map((t) => (t.key === key ? { ...t, [field]: value } : t)));
  }

  async function createTemplate(e) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    try {
      await onboardingApi.createTemplate({
        name: fd.get('name'),
        type: fd.get('type') || 'onboarding',
        description: fd.get('description') || null,
        tasks: tasks
          .filter((t) => t.title.trim())
          .map((t) => ({ title: t.title, ownerRole: t.ownerRole || null, offsetDays: Number(t.offsetDays) || 0 })),
      });
      form.reset();
      setTasks([{ key: rowKey++, title: '', ownerRole: 'hr_manager', offsetDays: 0 }]);
      setShowForm(false);
      setNotice('Template created');
      refresh();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to create template');
    }
  }

  return (
    <section data-testid="onboarding-templates-page" data-loading={loading ? 'true' : 'false'}>
      <header className="page-header">
        <div><h1>Journey Templates</h1><p className="muted">{items.length} templates</p></div>
        <button className="btn primary" data-testid="onboarding-template-create" onClick={() => setShowForm((s) => !s)}>
          {showForm ? 'Close' : '+ New Template'}
        </button>
      </header>

      {error && <div className="alert error">{error}</div>}
      {notice && <div className="alert">{notice}</div>}

      {showForm && (
        <form onSubmit={createTemplate} className="card form-card grid-form">
          <label>Name<input name="name" data-testid="onboarding-template-name-input" required /></label>
          <label>Type
            <select name="type" defaultValue="onboarding">
              <option value="onboarding">Onboarding</option>
              <option value="offboarding">Offboarding</option>
              <option value="transfer">Transfer</option>
            </select>
          </label>
          <label className="full">Description<textarea name="description" rows={2} /></label>
          <div className="full">
            <h4>Tasks</h4>
            {tasks.map((t) => (
              <div key={t.key} className="grid-form" style={{ gridTemplateColumns: '2fr 1fr 1fr', gap: 8, marginBottom: 6 }}>
                <input placeholder="Task title" value={t.title} onChange={(e) => updateTask(t.key, 'title', e.target.value)} data-testid="onboarding-template-task-title" />
                <input placeholder="Owner role" value={t.ownerRole} onChange={(e) => updateTask(t.key, 'ownerRole', e.target.value)} />
                <input placeholder="Offset days" type="number" value={t.offsetDays} onChange={(e) => updateTask(t.key, 'offsetDays', e.target.value)} />
              </div>
            ))}
            <button type="button" className="btn ghost" onClick={() => setTasks((p) => [...p, { key: rowKey++, title: '', ownerRole: 'hr_manager', offsetDays: 0 }])}>+ Add task</button>
          </div>
          <div className="full actions"><button className="btn primary" type="submit" data-testid="onboarding-template-submit">Create template</button></div>
        </form>
      )}

      <div className="card">
        <table className="data-table" data-testid="onboarding-template-list">
          <thead><tr><th>Name</th><th>Type</th><th>Tasks</th></tr></thead>
          <tbody>
            {items.map((t) => (
              <tr key={t.id} data-testid={`onboarding-template-row-${t.id}`}>
                <td>{t.name}</td>
                <td>{t.type}</td>
                <td>{t.task_count ?? '—'}</td>
              </tr>
            ))}
            {!loading && items.length === 0 && <tr><td colSpan={3} className="muted">No templates yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}
